import { CircularProgress, IconButton } from '@mui/material';
import { ReactElement } from 'react';
import { WidgetHeader, WidgetNumberBody, WidgetWrapper } from '../shared/all.styles';
import { Typography } from '../shared/typography';
import { Link } from '@mui/icons-material';

interface Props {
  title: string;
  loading?: boolean;
  value?: number ;
  color?: string;
  onLinkClick?: () => void;
}

export const WidgetNumber = ({ title, value, loading, color, onLinkClick }: Props): ReactElement => {
  return (
    <WidgetWrapper>
      <WidgetHeader>
        <Typography variant='subtitle2'>{title}</Typography>
        {onLinkClick && (
          <IconButton
            onClick={() =>{onLinkClick()}}
            color="primary" title="More">
            <Link/>
          </IconButton>
        )}
      </WidgetHeader>
      <WidgetNumberBody>
        {loading ? (
          <CircularProgress size={50} />
        ) : (
          <Typography variant='h4'  sx={{ color: color ?? 'primary.main' }}>
            {value}
          </Typography>
        )}
      </WidgetNumberBody>
    </WidgetWrapper>
  );
};
